import { Component, Input, Output, EventEmitter } from '@angular/core'
import { LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-information-cards',
  templateUrl: './information-cards.component.html'
})
export class InformationCardsComponent {

  @Input() identifier
  @Input() data
  @Input() defaultClass
  @Input() itemByRow
  @Output() page = new EventEmitter()

  constructor(
    public localDeviceDetector: LocalDeviceDetectorService
  ) { }

}
